import React, { Component } from 'react';
import StepFooter from '../StepFooter';
import PropTypes from 'prop-types';
import _ from 'lodash';

class Step1 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      learnForFun: null,
      professionId: '',
      possibleProfessions: props.professions,
      errors: {
        learnForFun: '',
        profession: ''
      },
      dirty: {
        learnForFun: false,
        profession: false
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.footerNext = this.footerNext.bind(this);
  }

  getErrors (state) {
    let errors = {learnForFun: '', profession: ''};
    let dirty = state.dirty;
    if (dirty.learnForFun && state.learnForFun === null) {
      errors.learnForFun = 'Please select a reason for learning before clicking next';
    }
    if (dirty.profession && (state.learnForFun === false) && state.professionId === '') {
      errors.profession = 'Please select a desired profession before clicking next';
    }
    return errors;
  }

  getMessage (errors) {
    return _.filter(_.values(errors), e => e)[0];
  }

  footerNext (event) {
    let state = this.state;
    state.dirty = {learnForFun: true, profession: true};
    state.errors = this.getErrors(state);
    this.setState(state);
    if (this.getMessage(state.errors)) {
      event.preventDefault();
    } else {
      this.props.handleNextClick({
        learnForFun: this.state.learnForFun,
        professionId: this.state.learnForFun ? 0 : Number(this.state.professionId)
      });
    }
  }

  handleChange (event) {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (value === 'false') {
      value = false;
    } else if (value === 'true') {
      value = true;
    }
    let state = this.state;
    state.dirty[name] = true;
    state[name] = value;
    // update the error mesage if there already was one
    if (this.getMessage(this.state.errors)) {
      state.errors = this.getErrors(state);
    }
    this.setState(state);
  }

  render () {
    return (
      <div className='registration__step' style={{'height': '510px'}}>
        <div className='registration__inner'>
          <p className='registration__step-indicator'>Step 1 of 4</p>
          <p className='kilo'>I want to learn BSL for...</p>

          <ul className='form-fields form-fields--compact'>
            <li>
              <label className='control radio'>
                <input id='learnfor1' name='learnForFun' type='radio' value='true'
                  checked={this.state.learnForFun === true}
                  onChange={this.handleChange}
                />
                <span className='control-indicator' />
                For fun/hobby/personal use
              </label>
            </li>
            <li>
              <label className='control radio'>
                <input id='learnfor2' name='learnForFun' type='radio' value='false'
                  checked={this.state.learnForFun === false}
                  onChange={this.handleChange}
                />
                <span className='control-indicator' />
                For work
                <span className='label-extra'>I work as, or want want to persue a profession as...</span>
                <div className={'select sub-input ' + (this.state.errors.profession && 'has-error')}>
                  <select name='professionId' id='' className={this.state.errors.profession && 'has-error'}
                    value={this.state.professionId} onChange={this.handleChange}>
                    <option value='0' disabled >Please choose one...</option>
                    {_.sortBy(this.state.possibleProfessions, ['title']).map((profession) => {
                      return (
                        <option value={profession.id} key={profession.id}>{profession.title}</option>
                      );
                    })}
                  </select>
                </div>
              </label>
            </li>
          </ul>

          <StepFooter
            handlePreviousClick={this.props.handlePreviousClick}
            handleNextClick={this.footerNext}
            errorMessage={this.getMessage(this.state.errors)}
          />
        </div>
      </div>
    );
  }
}

Step1.propTypes = {
  handlePreviousClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  professions: PropTypes.array.isRequired
};

export default Step1;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/Step1/index.js